import {
  CalendarCheck,
  CalendarClock,
  CalendarX,
  FileText,
  Clock,
  AlertCircle,
} from "lucide-react";

const META = {
  catalogue_envoye:  { label: "Catalogue envoyé",   icon: FileText,     cls: "bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300" },
  rdv_propose:       { label: "RDV proposé",        icon: CalendarClock, cls: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300" },
  rdv_confirme:      { label: "RDV confirmé",       icon: CalendarCheck, cls: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300" },
  rdv_decline:       { label: "RDV décliné",        icon: CalendarX,     cls: "bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300" },
  pas_de_reponse:    { label: "Pas de réponse",     icon: Clock,         cls: "bg-orange-50 text-orange-700 dark:bg-orange-950/40 dark:text-orange-300" },
  erreur_formulaire: { label: "Erreur formulaire",  icon: AlertCircle,   cls: "bg-zinc-100 text-zinc-600 dark:bg-zinc-800/60 dark:text-zinc-400" },
};

function fmtRdv(iso) {
  if (!iso) return "";
  try {
    return ` · ${new Date(iso).toLocaleString("fr-FR", {
      weekday: "short", day: "2-digit", month: "2-digit",
      hour: "2-digit", minute: "2-digit",
    })}`;
  } catch {
    return "";
  }
}

export default function ConversationStatusBadge({ status, rdvAt }) {
  const meta = META[status];
  if (!meta) return null;
  const Icon = meta.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium ${meta.cls}`}
      data-testid={`conv-status-${status}`}
    >
      <Icon className="h-3 w-3" />
      {meta.label}
      {(status === "rdv_confirme" || status === "rdv_propose") && fmtRdv(rdvAt)}
    </span>
  );
}
